import { cn, NoddiIcon, type NoddiIconName } from 'noddi-ui-common';
import type { ReactNode } from 'react';
import type { TireLeadSeverity } from './tireLeadReasonCopy';

const RISK_TILE_CLASS: Record<TireLeadSeverity, string> = {
  high: 'bg-danger50 text-dangerDark',
  medium: 'bg-warning50 text-warningDark',
  info: 'bg-lightPurple text-darkPurple'
};

type Props = {
  risks: string[];
  severity: TireLeadSeverity;
  /** Extra rows after the risks, e.g. the time until the legal limit. */
  children?: ReactNode;
};

/** What happens if the customer keeps driving on the tires, one icon row per risk. */
export const RiskList = ({ risks, severity, children }: Props) => {
  if (risks.length === 0 && !children) {
    return null;
  }
  return (
    <div className='flex flex-col gap-3 border-t border-border pt-4'>
      {risks.map((risk) => (
        <div key={risk} className='flex items-center gap-3'>
          <RiskIcon icon='TriangleAlert' severity={severity} />
          <span className='font-medium'>{risk}</span>
        </div>
      ))}
      {children}
    </div>
  );
};

export const RiskIcon = ({ icon, severity }: { icon: NoddiIconName; severity: TireLeadSeverity }) => (
  <span className={cn('flex size-8 flex-none items-center justify-center rounded-lg', RISK_TILE_CLASS[severity])}>
    <NoddiIcon name={icon} size='small' />
  </span>
);
